<template>
  <div class="hello">
    <div class="card">
        <div class="card-header">
          <h5>Busca Personalizada</h5>
          
        </div>  
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <label>Desenvolvimento</label>
                <multiselect  
                  v-model="filter.desenvolvimento" 
                  :options="filters.desenvolvimento"
                  placeholder="Selecione a opção desejada"
                  select-label="Pressione para selecionar"
                  :multiple="true"
                  
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  >
                  
                </multiselect>
              </div>
              <div class="col-md-6 col-sm-12">
                <label>Gestão</label>
                <multiselect  
                  v-model="filter.gestao" 
                  :options="filters.gestao"
                  placeholder="Selecione a opção desejada"
                  select-label="Pressione para selecionar"
                  :multiple="true"
                  
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  ></multiselect>
              </div>
              <div class="col">
                
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-sm-12">
                <label>Experiência</label>
                <multiselect 
                  v-model="filter.tempExp" 
                  :options="filters.tempExp"
                  placeholder="Selecione a opção desejada"
                  select-label="Pressione para selecionar"
                  :multiple="false"
                  
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  ></multiselect>
              </div>
              <div class="col-md-6 col-sm-12">
                <label>Expectativa de remuneração</label>
                <multiselect 
                  v-model="filter.remuneracao" 
                  :options="filters.remuneracao"
                  placeholder="Selecione a opção desejada"
                  select-label="Pressione para selecionar"
                  ::multiple="false"
                  
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  ></multiselect>
              </div>
              <div class="col">
                
              </div>
            </div>
            
            <div class="row">
              
              <div class="col-lg-2 offset-lg-10 text-right" >
                <br>
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  @click.prevent="applyFilters()">
                  Pesquisar
                </button>
              </div>
            </div>
          </div>
        </div>
    </div>
    
    <div class="card">
      <div class="card-header">
        <h5>Lista de Profissionais</h5>
        <!--<div class="input-group ">-->
        </div>  
      
      <!--</div>-->
      
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Email</th>
                <th scope="col">Telefone</th>
                
                <th scope="col"><div class="text-center">Mais Informações</div></th>
                
              </tr>
            </thead>
            <tbody>
              <tr v-if="dataSearch.length == 0">
                <td colspan="4"
                    class="text-center font-italic">
                    <label> Nenhum registro foi cadastrado </label>
                  </td>
              </tr>
              <tr v-for="(row, index) in dataSearch"
                :key="row.id">
                
                <td>{{row.Nome}}</td>
                <td>{{row.Email}}</td>
                <td>{{row.Telefone}}</td>
                <td>
                  <div class="text-center">
                    <a  style="" class="fas fa-eye"
                        href="#/iracema"
                        @click="selectRow(index)"
                        v-b-modal.modal1>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
    </div>

    <div>
      

      <!-- Modal Component -->
      <b-modal id="modal1" title="Informações Detalhadas" size="lg" ok-title="Fechar" ok-only="">
        <ModalContent v-bind="{data: dataSearch[index]}"></ModalContent>
      </b-modal>
    </div>


  </div>
</template>

<script>
import Service from '@/services/IracemaService';
import Multiselect from 'vue-multiselect'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import ModalContent from   '@/components/SalaIracema/IracemaModal.vue'
export default {
  name: 'Iracema',
  data () {
    return {
     data: [],
     dataSearch: [],
     filters:{
       tempExp: ['Menos de 1 ano','Entre 1 e 3 anos','Entre 3 e 5 anos', 'Acima de 5'],
       remuneracao: ['Um Salário Mínimo', 'Até R$ 3.000,00', 'entre R$ 3.0000 e R$ 5.000,00', 'acima de R$ 5.000,00', 'Trabalho por hora','A combinar'],
       desenvolvimento: ['Banco de Dados','Computação Gráfica','Computação em Nuvens','Inteligência Artificial','Internet das Coisas - IoT', 'Programação front-end', 'Programação back-end', 'Soluções em Automação', 'Sites com Wordpress ou Wix'],
       gestao: ['Contábil', 'Projetos', 'Métodos Ágeis', 'Design Thinking', 'RH', 'Financeira'],
       disponibilidade: ['Freelancer ON-LINE', 'Freelancer OFF-LINE', 'Estagiário', 'Contrato CLT', '8h/dia', '4h/dia', '2h/dia', 'Final de Semana']

     },
     filter: {},
     filterAux: {},
     right: false,
     index: 0
    }
  },
  components:{
    Multiselect,
    ModalContent
    

  },
  
  methods: {
    populate() {
       let promise = new Service().getAll();
       promise.then(
        sucess => {
          this.data = sucess;
          this.dataSearch = this.data;
        },
        err => {
          console.log(err);
        }
      );

    },
    applyFilters() {
      this.dataSearch = []
      this.data.forEach(value => {
          this.isEmpty(this.filter, value)
          if(value.TempoExp === this.filterAux.tempExp && value.Remuneracao === this.filterAux.remuneracao){
            this.right = true
            this.filterAux.desenvolvimento.forEach(dev => {
              let rgxp = new RegExp(dev, "g");
              if(!value.Desenvolvimento.match(rgxp)){
                this.right  = false
              }
            })
            this.filterAux.gestao.forEach(ges => {
              let regex = new RegExp(ges, "g");
              if(!value.Gestao.match(regex)){
                this.right  = false
              }
            })
            if(this.right)
              this.dataSearch.push(value)
          }
          
          
        }
      
      )
      
    },
    isEmpty(filter2, value2) {
      if(filter2.tempExp == null || filter2.tempExp == undefined || filter2.tempExp == ''){
        this.filterAux.tempExp = value2.TempoExp
      }
      else {
        this.filterAux.tempExp = this.filter.tempExp
      }
      if(filter2.remuneracao == null || filter2.remuneracao == undefined || filter2.remuneracao == ''){
        this.filterAux.remuneracao = value2.Remuneracao
      }else {
        this.filterAux.remuneracao = this.filter.remuneracao
      }
      if(filter2.desenvolvimento == null || filter2.desenvolvimento == undefined){
        this.filterAux.desenvolvimento = value2.Desenvolvimento.split(', ')
      }
      else{
        this.filterAux.desenvolvimento = this.filter.desenvolvimento
      }
      if(filter2.gestao == null || filter2.gestao == undefined){
        this.filterAux.gestao = value2.Gestao.split(', ')
      }
      else{
        this.filterAux.gestao = this.filter.gestao
      }
    },

    selectRow(index) {
      console.log('Index', index)
      this.index = index
    }
  },

  mounted () {
    this.populate();
  },
  watch:  {
   
  }
}
</script>


<style scoped>
.card{
  margin: 30px;
  
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/SalaIracema/Iracema.vue